import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from "../Tools/FiltersController";
import { FiltersWidget } from "../FiltersWidget";


export class ColorFilter implements IFilter {
    id: string;
    name?: string | null;
    type: string;
    parentGroup: FilterGroup;
    controller: FiltersController;
    constructor(parentGroup: FilterGroup) {
        this.id = "color";
        this.name = null;
        this.type = "color";
        this.parentGroup = parentGroup;
        this.controller = new FiltersController();
    }

    html(): string {
        let html = `
        <div class="filter" style="display: flex;align-items: center;justify-content: center;margin:0 auto;max-width: 380px;width: 100%;">
            <span>Recherche par couleur</span>
                <input class="color-picker">
            <button id="colorButton" class="btn-default"
                style="padding: 0; margin: 0; padding-bottom: 2px;">
                <i class="glyphicon glyphicon-remove"></i>
            </button>
        </div>
        `;

        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            FiltersWidget.initColorPicker();
            if (!this.controller) {
                console.error('FiltersWidget.controller is not defined');
                return;
            }
            this.controller.addEventListener('mousedown', () => {
                FilterGroup.filters.useColorSearch = false;
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
            }, 'colorButton');

        }, 50);

        return html;
    }

    destroy(): void {
        this.controller.destroy();
    }
}